import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { Breakpoints } = constants.breakpoints;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const navContainer = {
  background: ui.neutral[25],
  padding: "2rem 0.5rem",
  width: "14.4375rem",
  [breakpoint.between(Breakpoints.sm, Breakpoints.md)]: {
    width: "11.625rem",
  },
  [breakpoint.upTo(Breakpoints.sm)]: {
    display: "none",
  },
};

export const sidebarTitle = {
  color: ui.neutral[700],
  fontSize: "0.75rem",
  fontWeight: "bold",
  lineHeight: "133%",
  letterSpacing: "1px",
  padding: "0 1rem",
  textTransform: "uppercase",
  margin: 0,
};

export const sidebarListContainer = {
  marginBottom: "2.25rem",
  marginTop: "0.75rem",
  padding: 0,
};

export const sidebarList = {
  listStyle: "none",
};

export const sidebarSubMenuListContainer = {
  marginBottom: 0,
  padding: 0,
};

const selectedStyle = {
  background: ui.white[50],
  borderRadius: "2px 8px 2px 2px",
  position: "relative",
};

export const sidebarLink = (isNewLink) => {
  return [
    {
      color: ui.neutral[600],
      fontSize: "0.875rem",
      lineHeight: "171%",
      padding: "0.25rem 1rem",
      position: "relative",
      textDecoration: "none",
      width: "100%",
      minWidth: 0,
      "&:hover": selectedStyle,
      [breakpoint.downTo(Breakpoints.xs)]: {
        fontSize: "0.875rem",
        lineHeight: "171%",
      },
      "& > div": {
        overflow: isNewLink ? "visible" : "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
  ];
};

export const selectedLink = [
  selectedStyle,
  {
    "&::before": {
      background: ui.core[500],
      borderRadius: "2px",
      content: '""',
      height: "1.5rem",
      left: "0.25rem",
      position: "absolute",
      top: "0.25rem",
      width: "0.25rem",
      zIndex: 1,
    },
  },
];

export const relatedOptionsContainerCss = {
  display: "flex",
  button: {
    marginRight: 15,
  },
};

export const relatedOptionsContainerSelectedCss = [
  relatedOptionsContainerCss,
  selectedStyle,
  {
    color: ui.neutral[700],
    paddingLeft: 10,
    a: {
      fontWeight: "bold",
    },
    "&::before": {
      background: ui.core[700],
      borderRadius: "2px",
      content: '""',
      height: "1.5rem",
      left: "0.25rem",
      position: "absolute",
      top: "0.25rem",
      width: "0.25rem",
      zIndex: 1,
    },
  },
];
